import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { MenuItem, Select } from '@material-ui/core';

const styles = theme => ({
  root: {
    padding: 0,
    backgroundColor: theme.palette.facet.accentBlue6,
    margin: theme.spacing(0, 1),
    color: theme.palette.primary.main,
    ...theme.typography.h4,
  },
});

const ScheduleSectionToggle = ({
  className,
  classes,
  onClick,
  options,
  selected,
}) => {
  return (
    <Select
      className={classNames(classes.root, className)}
      onChange={event => onClick(event.target.value)}
      value={selected}
    >
      {options.map(option => (
        <MenuItem
          key={option}
          value={option}
        >
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};

ScheduleSectionToggle.defaultProps = {
  options: [],
  selected: '',
  className: '',
};

ScheduleSectionToggle.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(ScheduleSectionToggle);
